export const Placeholders = {
  AppLocation: '{appLocation}',
  Media: '{media}',
  PassID: '{passID}',
  PassId: '{passId}',
};
